import { render } from "./ViewAuswahl.vue?vue&type=template&id=388a9128&scoped=true"
import script from "./ViewAuswahl.vue?vue&type=script&lang=js"
export * from "./ViewAuswahl.vue?vue&type=script&lang=js"

import "./ViewAuswahl.vue?vue&type=style&index=0&id=388a9128&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388a9128"]])

export default __exports__